import { Typography } from '@mui/material';
import Alert from 'further-ui/components/Alert';
import { Column } from 'further-ui/components/Layout';
import TypographyButton from 'further-ui/components/TypographyButton';
import { CalendarDay } from 'further-ui/utils';
import { ReactNode, useState } from 'react';

type Props = {
  children: ReactNode;
  showFutureTransactionsMessage?: boolean;
  bankOperationDate: CalendarDay;
  sourceActionDate?: CalendarDay;
};

const SourceTransactionsContainer: React.FC<Props> = ({
  children,
  showFutureTransactionsMessage,
  bankOperationDate,
  sourceActionDate,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const futureTransactionsMessage = sourceActionDate?.isAfter(bankOperationDate)
    ? 'As this future transaction was booked without an FX rate, the source transaction FX rate will be booked to equal the FX rate at cash settlement.'
    : "As this past transaction was booked without an FX rate, the source transaction will be booked with the FX rate as at the transaction's ledger date";

  return (
    <Column spacing="lg">
      {showFutureTransactionsMessage ? (
        <>
          <Alert iconPosition="start" severity="info">
            {futureTransactionsMessage}{' '}
            <TypographyButton
              text="Show source transaction"
              textDecoration="none"
              onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
              showExpandableStartAdornment
              isExpanded={isExpanded}
            />
          </Alert>
          {isExpanded && children}
        </>
      ) : (
        <>
          <Typography variant="body2">
            <TypographyButton
              text="Show source transaction"
              textDecoration="none"
              onClick={() => setIsExpanded((isExpanded) => !isExpanded)}
              showExpandableStartAdornment
              isExpanded={isExpanded}
            />
          </Typography>
          {isExpanded && children}
        </>
      )}
    </Column>
  );
};

export default SourceTransactionsContainer;
